import React from "react";
import ButtonLoading from "../Button/ButtonLoading";
import { Modal, ModalContent } from "@nextui-org/react";
import ModalBasic from "../ModalBasic";
import Button from "../Button/Button";

export default function ModalConfirmation({
  title,
  text,
  showConfirmation,
  setShowConfirmation,
  ConfirmFunction,
  CloseFunction,
}) {
  return (
    <Modal
      // name="modal-confirmation"
      // enClose={true}
      // id="delete-modal"
      aria-hidden={false}
      placement="center"
      isOpen={showConfirmation}
      onOpenChange={(isOpen) => setShowConfirmation(isOpen)}
      hideCloseButton
      isDismissable={false}
      classNames={{ backdrop: "z-[51]", wrapper: "z-[60]" }}
      // noPadding
    >
      <ModalContent className="pointer-events-auto">
        {(onClose) => (
          <div className="flex flex-col items-center space-y-4 p-5 px-10 text-center">
            {/* Icon */}
            <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-rose-100">
              <svg
                className="h-4 w-4 shrink-0 fill-current text-rose-500"
                viewBox="0 0 16 16"
              >
                <path d="M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm0 12c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1zm1-3H7V4h2v5z" />
              </svg>
            </div>
            {/* Content */}
            <div className="w-full">
              {/* Modal header */}
              <div className="mb-2">
                <div className="text-lg font-semibold text-slate-800">
                  {title}
                </div>
              </div>
              {/* Modal content */}
              <div className="mb-4 text-sm">
                <div className="space-y-2">
                  <p>{text}</p>
                </div>
              </div>
              {/* Modal footer */}
              <div className="flex justify-center space-x-2">
                <Button
                  onClick={() => {
                    onClose();
                    if (CloseFunction) {
                      CloseFunction();
                    }
                  }}
                  label="Kembali"
                  variant="default"
                  size="sm"
                />
                <Button
                  label="Konfirmasi"
                  size="sm"
                  variant="gradient"
                  onClick={() => {
                    onClose();
                    ConfirmFunction();
                  }}
                  // isLoading={buttonLoading}
                />
              </div>
            </div>
          </div>
        )}
      </ModalContent>
    </Modal>
  );
}
